export enum EditionState{
    Draft = 'draft',
    Published = 'published'
}